import { render } from "./TitreComponents.vue?vue&type=template&id=0a1f2232"
import script from "./TitreComponents.vue?vue&type=script&lang=js"
export * from "./TitreComponents.vue?vue&type=script&lang=js"

import "./TitreComponents.vue?vue&type=style&index=0&id=0a1f2232&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__